import publicHeaderIcon from "../../../assets/icons/public-header-icon.png";

const Header = () => (
  <div className="public-form-header">
    <img
      src={publicHeaderIcon}
      alt="אנונימיסט - שאלות עם טוויסט"
      className="public-form-logo"
    />
  </div>
);

export default Header;
